export enum LocalStorageKey {
	CALENDAR_TOOLBAR = 'calendarToolbar',
}
